<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row>
        <el-col :span="12">
          <h1 class="pb-15">
            <v-svg class="voxo-green" sprite="group-2" />
            Users
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px;"></i>
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input
            v-model="search"
            placeholder="Search"
            clearable>
          </el-input>
          <el-button class="ml-10" @click="showModal('Create')">Add New</el-button>
        </div>
        <div class="box right">
          <el-pagination
            small
            background
            layout="prev, pager, next"
            @current-change="pageSet"
            @next-click="pageNext"
            @prev-click="pagePrevious"
            :current-page="page"
            :page-size="limit"
            :pager-count="5"
            :total="total"
          />
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="userList"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <!-- FORM COMPONENT -->
    <user-form
      ref="userForm"
      :visible="modalVisible"
      :context="modalContext"
      :recordId="modalModelId"
      :timezoneOptions="timezoneOptions"
      :partnerOptions="partnerOptions"
      @modalClosed="handleModalClose">
    </user-form>

  </div>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex';
  import userForm from '../users/components/form';
  import feathersClient from '../../../feathers/feathers-client';
  import debounce from 'lodash/debounce';

  export default {
    name: 'AdministratorsTable',
    components: {userForm},
    data() {
      return {
        tableLoading: false,
        search: '',
        visibleActionsId: '',
        modalModelId: '',
        modalContext: '',
        modalVisible: false,
        limit: 100,
        page: 1,
        pages: 1,
        total: 0,
        timezoneOptions: [],
        partnerOptions: [],
        tableColumns: [
          {
            field: 'avatar',
            sortable: false,
            showOverflow: false,
            width: 75,
            slots: {
              default: ({row}) => {
                return [
                  <div class="avatar-group">
                    {row.avatarPath &&
                    <div class="contact-avatar">
                      <img src={row.avatarPath} alt={row.name} title={row.name}/>
                    </div>
                    }
                    {!row.avatarPath &&
                    <div class="contact-avatar">
                      {row.email.substring(0, 1).toUpperCase()}
                    </div>
                    }
                  </div>
                ]
              }
            }
          },
          {
            field: 'email',
            title: 'Email',
            sortable: true,
            minWidth: 200,
            showOverflow: true
          },
          {
            field: 'userRole',
            title: 'Role',
            sortable: true,
            minWidth: 150,
            showOverflow: false,
            slots: {
              default: ({row}) => {
                return [
                  <span>{this.roleTitle(+row.userRole)}</span>
                ]
              }
            }
          },
          {
            field: 'actions',
            title: '',
            minWidth: '150',
            showOverflow: false,
            slots: {
              default: ({row}) => {
                return [
                  <div v-show={row.id === this.visibleActionsId}>
                    <el-button
                      id={'edit-'+ row.id}
                      icon="el-icon-edit"
                      onClick={() => this.showModal('Edit', row.id)}
                      class="table-action-button icon-blue"
                    />
                    <el-button
                      id={'delete-'+row.id}
                      icon="el-icon-delete"
                      onClick={() => this.deleteRecord(row.id)}
                      class="table-action-button icon-red"
                    />
                  </div>
                ]
              }
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters('users', {userProfile: 'get', getUserList: 'find'}),
      user() {
        return this.$store.state.auth.user
      },
      userList() {
        return this.getUserList({query: {$sort: {email: 1}}}).data;
      },
      selectedTenant() {
        return this.$store.state.selectedTenant;
      }
    },
    watch: {
      user() {
        this.queryUsers();
      },
      page: debounce(function () { this.queryUsers() }, 500),
      search: debounce(function () { this.queryUsers() }, 500)
    },
    methods: {
      ...mapActions('users', {
        findUsers: 'find',
        removeUser: 'remove'
      }),

      roleTitle(val) {
        if (val === 1) return 'Platform Admin';
        if (val === 3) return 'Account Admin';
        if (val === 5) return 'User';
        if (val === 7) return 'Queue Manager';
        if (val === 9) return 'Reports Admin';
        if (val === 11) return 'Partner Admin'
        if (val === 12) return 'Pharmacy Owner';
        if (val === 13) return 'Pharmacy Admin';
        if (val === 14) return 'Pharmacy User';
        return 'No Role';
      },

      queryUsers() {
        this.$store.commit('users/clearList');
        this.tableLoading = true;
        this.findUsers({
          query: {
            $limit: this.limit,
            $skip: this.page > 1 ? (this.limit * (this.page - 1)) : 0,
            $sort: {email: 1},
            filter: this.search,
          }
        }).then( (response) => {
          this.limit = response.limit;
          this.pages = Math.ceil(response.total / response.limit);
          this.total = response.total;

          this.page = this.page > this.pages ? 1 : this.page;
          this.tableLoading = false;
        });
      },

      showModal(context, editId = null) {
        this.modalVisible = true;
        this.modalContext = context;
        this.modalModelId = editId;
      },

      //General Form and Table Operations
      cellClicked(data){
        if(data.column.property !== 'actions'){
          this.showModal('Edit', data.row.id);
        }
      },

      rowHover(data){
        this.visibleActionsId = data.row.id;
      },

      rowLeave(){
        this.visibleActionsId = "";
      },

      deleteRecord(id) {
        this.$confirm('Permanently delete this user?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => {
            this.removeUser(id)
              .then(res => {
                this.$notify({
                  title: 'Success',
                  message: 'User ' + res.email + ' has been removed!',
                  type: 'success'
                });
              })
              .catch(error => {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: 'error'
                });
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Delete Canceled'
            })
          });
      },

      removeListeners(){
        feathersClient.service('users').removeListener('created');
        feathersClient.service('users').removeListener('patched');
        feathersClient.service('users').removeListener('removed');
      },
      handleModalClose(){
        this.modalVisible = false;
        this.modalContext = '';
      },
      pageNext () {
        if (this.page < this.pages) {
          this.page += 1;
        }
      },
      pagePrevious () {
        if (this.page > 1) {
          this.page -= 1;
        }
      },
      pageSet (page) {
        this.page = page;
      },
      queryTimezones(){
        feathersClient.service('timezones').find({
          query: {
            $sort: {name: 1}
          }
        }).then( res => this.timezoneOptions = res);
      },
      queryPartnerOptions(){
        feathersClient.service('partners').find().then(res => {
          this.partnerOptions = res;
        })
      }
    },
    created() {
      if (this.user) {
        this.queryUsers();
        this.queryPartnerOptions();
        this.queryTimezones();
      }
    },
    beforeDestroy() {
      this.removeListeners();
      this.$store.commit('users/clearList');
      this.$refs.xGrid.$destroy();
      this.$refs.userForm.$destroy();
    }
  }
</script>



